import GoogleMapBaseStyle from './GoogleMapBaseStyle';

const GoogleMapRoadmapPOIOffStyle = [
  ...GoogleMapBaseStyle,
  {
    featureType: 'poi',
    elementType: 'all',
    stylers: [ {
      visibility: 'off',
    } ],
  },
  {
    featureType: 'poi.park',
    stylers: [ {
      visibility: 'on',
    } ],
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry.fill',
    stylers: [ {
      color: '#e1e2d9',
    } ],
  },
  {
    featureType: 'poi.park',
    elementType: 'labels',
    stylers: [ {
      visibility: 'off',
    } ],
  },
];

export default GoogleMapRoadmapPOIOffStyle;
